// Module
var code = "<div class=bible> <div class=bibletext> <p> </p><h2 class=pn>Psalm&nbsp;36</h2><p><span class=cwvnum>1</span>&nbsp;&nbsp;Sin whispers to the wicked, in the depths of their heart;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;there is no fear of God before their eyes.<br> </p> </div></div>";
// Exports
module.exports = code;